import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  eyebrow: string;
  title: string;
  intro?: string;
  image?: string;
  tone?: 'paper' | 'coffee' | 'pennant';
  align?: 'left' | 'center';
  children?: React.ReactNode;
};
const TONES = {
  paper: {
    bg: 'bg-paper-warm',
    title: 'text-coffee',
    body: 'text-ink/65',
    eyebrow: 'text-pennant'
  },
  coffee: {
    bg: 'bg-coffee',
    title: 'text-paper',
    body: 'text-paper/70',
    eyebrow: 'text-paper/55'
  },
  pennant: {
    bg: 'bg-pennant',
    title: 'text-paper',
    body: 'text-paper/70',
    eyebrow: 'text-paper/55'
  }
};

/** Shared page opener for the content / help / utility templates. */
export function PageHero({
  eyebrow,
  title,
  intro,
  image,
  tone = 'paper',
  align = 'left',
  children
}: Props) {
  const t = TONES[tone];
  const centered = align === 'center';
  return <section className={`${t.bg} w-full`} data-id="element-184" data-mp="18qwf4w1as6kb">
      <div className={`mx-auto max-w-[1400px] px-6 ${image ? 'pt-20 md:pt-28' : 'py-20 md:py-32'}`} data-id="element-185" data-mp="18q4l3pncmgw5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className={centered ? 'mx-auto max-w-3xl text-center' : 'max-w-4xl'} data-id="element-186" data-mp="32hivb1murh5k">
          <p className={`type-eyebrow mb-6 text-[11px] ${t.eyebrow}`} data-id="element-187" data-mp="3c9ydo022a7qz">
            {eyebrow}
          </p>
          <h1 className={`type-display text-5xl md:text-7xl ${t.title}`} data-id="element-188" data-mp="37fkgbs3u9qjo">
            {title}
          </h1>
          {intro && <p className={`type-body mt-7 text-lg ${t.body} ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-189" data-mp="3gaia11et97c2">
              {intro}
            </p>}
          {children && <div className="mt-9" data-id="element-190" data-mp="3q8fvxi976s1i">{children}</div>}
        </motion.div>

        {image && <motion.div initial={{
        opacity: 0,
        y: 28
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-14 overflow-hidden rounded-4xl md:mt-20" data-id="element-191" data-mp="20tro7ubjxy9t">
            <img src={image} alt="" className="h-[42vh] w-full object-cover md:h-[58vh]" data-id="element-192" data-mp="2piujravbehvn" />
          </motion.div>}
      </div>
    </section>;
}